import React, {useState} from "react";
import ReactEcharts from "echarts-for-react"; 
import { Draggable } from "leaflet";
function GraphAleas2({myDataMoy, myDataMax, myDataMin, myDataQ1, myDataQ3, degre, aleas, print}) {  
  const dataLegend = ['Maximum', '25%', 'Moyenne', '75%', 'Minimum']
  const [dataType, setDataType] = useState('Valeur');
  const myDataMaxDif = [0, myDataMax[1]-myDataMax[0], myDataMax[2]-myDataMax[0], myDataMax[3]-myDataMax[0], myDataMax[4]-myDataMax[0], myDataMax[5]-myDataMax[0], myDataMax[6]-myDataMax[0]]
  const myDataMinDif = [0, myDataMin[1]-myDataMin[0], myDataMin[2]-myDataMin[0], myDataMin[3]-myDataMin[0], myDataMin[4]-myDataMin[0], myDataMin[5]-myDataMin[0], myDataMin[6]-myDataMin[0]]
  const myDataMoyDif = [0, myDataMoy[1]-myDataMoy[0], myDataMoy[2]-myDataMoy[0], myDataMoy[3]-myDataMoy[0], myDataMoy[4]-myDataMoy[0], myDataMoy[5]-myDataMoy[0], myDataMoy[6]-myDataMoy[0]]
  const myDataQ1Dif = [0, myDataQ1[1]-myDataQ1[0], myDataQ1[2]-myDataQ1[0], myDataQ1[3]-myDataQ1[0], myDataQ1[4]-myDataQ1[0], myDataQ1[5]-myDataQ1[0], myDataQ1[6]-myDataQ1[0]]
  const myDataQ3Dif = [0, myDataQ3[1]-myDataQ3[0], myDataQ3[2]-myDataQ3[0], myDataQ3[3]-myDataQ3[0], myDataQ3[4]-myDataQ3[0], myDataQ3[5]-myDataQ3[0], myDataQ3[6]-myDataQ3[0]]

    const getOptions = () => {
      
      let options = {
        grid: {
          right: '15%',
        },
        legend: {
          data: dataLegend,
          orient: 'vertical', // Placer la légende à droite
          right: 0, // Ajuster la distance du bord droit
          bottom : '20%',
          height: '100%',
          textStyle: {
            fontSize: 16, // Ajustez la taille de la police de la légende selon vos besoins
          },
          itemHeight: 0, // Ajuste la hauteur de chaque élément de légende
          itemWidth: 30, // Ajuste la largeur de chaque symbole dans la légende
          itemGap:60
       },
        xAxis: {
            type: 'category',
            data: ['2020','2025','2030','2035', '2040', '2045', '2050'],
            name: 'Risques',
            nameTextStyle: {
              fontSize: 16 // Ajustez la taille de la police selon vos besoins
            },
            axisLabel: {
              fontSize: 16, // Ajustez la taille de la police des valeurs de l'axe Y selon vos besoins
              
            }
          },
          yAxis: {
            type: 'value',
            name: 'Perte en %',
            nameTextStyle: {
              fontSize: 16 // Ajustez la taille de la police selon vos besoins
            },
            axisLabel: {
              fontSize: 16 // Ajustez la taille de la police des valeurs de l'axe Y selon vos besoins
            }
          },
          series: [
            {
              name: 'Maximum',
              data: dataType === 'Diff' ?myDataMaxDif: myDataMax,
              type: 'line',
              smooth: true,
              symbol: 'none',
              symbolSize: 10,
              lineStyle: {
                width: 2, // Ajustez la largeur de la ligne selon vos besoins
                type: 'dashed',
              },
              itemStyle: {
                color: 'red'
              }
            },
            {
              name: '25%',
              data: dataType === 'Diff' ?myDataQ3Dif : myDataQ3,
              type: 'line',
              smooth: true,
              symbol: 'none',
              symbolSize: 10,
              lineStyle: {
                width: 4, // Ajustez la largeur de la ligne selon vos besoins
              },
              itemStyle: {
                color: 'orange'
              }
            },
            {
              name: 'Moyenne',
              data: dataType === 'Diff' ?myDataMoyDif: myDataMoy,
              type: 'line',
              smooth: true,
              symbol: 'none',
              symbolSize: 10,
              lineStyle: {
                width: 4, // Ajustez la largeur de la ligne selon vos besoins
              },
              itemStyle: {
                color: 'yellow'
              }
            },
            {
              name: '75%',
              data: dataType === 'Diff' ? myDataQ1Dif : myDataQ1,
              type: 'line',
              smooth: true,
              symbol: 'none',
              symbolSize: 10,
              lineStyle: {
                width: 4, // Ajustez la largeur de la ligne selon vos besoins
              },
              itemStyle: {
                color: '#A3E31B'
              }
            },
            {
              name: 'Minimum',
              data: dataType === 'Diff' ? myDataMinDif : myDataMin,
              type: 'line',
              smooth: true,
              symbol: 'none',
              symbolSize: 10,
              lineStyle: {
                width: 2, // Ajustez la largeur de la ligne selon vos besoins
                type: 'dashed',
              },
              itemStyle: {
                color: 'green'
              }
            }
          ]
      };
  
      return options;
    };
  

    return (
      <div style={{marginBottom:print === true ? "10px" : "20px", width: print === true ? '60%' : '80%',  marginTop:print === true ? '10px' : '30px'}}>
        <div className="row">
         <ReactEcharts option={getOptions()} style={{ height: '100%', width:'100%',height: print === true ? '550px' :  '450px' }} />
          <div style={{display:'flex', width:'100%',justifyContent:'center', width:'12%', flexDirection:'column', marginLeft:'5px'}}>
            <button onClick={() => setDataType('Valeur')} className="validation paragraphe" style={{marginTop:'0px', marginLeft:'0px', marginBottom:'10px', width:'120%', height:'120px', backgroundColor : dataType === "Valeur" ? '#ACE86B' : "white"}}>
              Valeur
            </button>
            <button onClick={() => setDataType('Diff')} className="validation paragraphe" style={{marginTop:'0px', marginLeft:'0px', width:'120%', height:'120px', backgroundColor : dataType === "Diff" ? '#ACE86B' : "white"}}>
              Par rapport à 2020
            </button>
          </div>
        </div>
    </div>
  
  );
}

export default GraphAleas2;
  